import(/* webpackMode: "eager", webpackExports: ["useLocalStorage"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@TheFuturePlace/drabble/dist/hooks/useLocalStorage.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/saliant/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrimaryFeatures"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/saliant/components/PrimaryFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/themes/saliant/images/background-call-to-action.webp");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/themes/saliant/images/background-faqs.webp");
